<template>
  <div class="resource-enter-container">
    <ds-page-header :title="$t('resourceEnterManage.page.title')" :subtitle="$t('resourceEnterManage.page.subtitle')">
      <template #extra>
        <span class="ds-num ds-order">{{ $t('resourceEnterManage.orderId') }}：{{ resourceEnterManageInfo.applyOrderId }}</span>
        <el-button type="primary" size="small" icon="el-icon-check" @click="handleSubmit">{{ $t('resourceEnterManage.submit') }}</el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left><span class="ds-panel__title">{{ $t('resourceEnterManage.page.title') }}</span></template>
      </ds-toolbar>
      <ds-data-table :data="resourceEnterManageInfo.purchaseApplyDetailVo" border :empty-description="$t('resourceEnterManage.page.empty')"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column prop="rstName" :label="$t('resourceEnterManage.itemType')" align="center" min-width="120">
          <template slot-scope="scope">{{ scope.row.rstName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="resName" :label="$t('resourceEnterManage.itemName')" align="center" min-width="140" />
        <el-table-column prop="specName" :label="$t('resourceEnterManage.itemSpec')" align="center" width="110">
          <template slot-scope="scope">{{ scope.row.specName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="resCode" :label="$t('resourceEnterManage.itemCode')" align="center" width="120">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.resCode || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="stock" :label="$t('resourceEnterManage.itemStock')" align="center" width="100">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.stock }}</span></template>
        </el-table-column>
        <el-table-column prop="standardPrice" :label="$t('resourceEnterManage.referencePrice')" align="center" width="110">
          <template slot-scope="scope"><span class="ds-num">￥{{ scope.row.standardPrice }}</span></template>
        </el-table-column>
        <el-table-column prop="quantity" :label="$t('resourceEnterManage.applyQuantity')" align="center" width="100">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.quantity }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('resourceEnterManage.purchaseQuantity')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-input v-model.number="scope.row.purchaseQuantity" type="number" :placeholder="$t('resourceEnterManage.purchaseQuantityPlaceholder')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('resourceEnterManage.purchasePrice')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-input v-model.number="scope.row.price" type="number" :placeholder="$t('resourceEnterManage.purchasePricePlaceholder')" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('resourceEnterManage.supplier')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-select v-model="scope.row.rsId" :placeholder="$t('resourceEnterManage.selectSupplier')" style="width:100%">
              <el-option v-for="supplier in resourceEnterManageInfo.resourceSuppliers" :key="supplier.rsId" :label="supplier.supplierName" :value="supplier.rsId" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="$t('resourceEnterManage.remark')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.purchaseRemark" type="text" :placeholder="$t('resourceEnterManage.remarkPlaceholder')" clearable />
          </template>
        </el-table-column>
      </ds-data-table>
    </div>
  </div>
</template>

<script>
import { listPurchaseApplys, listResourceSuppliers, resourceEnter } from '@/api/resource/resourceEnterManageApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'ResourceEnterManageList',
  components: { DsPageHeader, DsToolbar, DsDataTable },
  data() {
    return {
      resourceEnterManageInfo: { purchaseApplyDetailVo: [], resourceSuppliers: [], selectResIds: [], applyOrderId: '', taskId: '', resOrderType: '' }
    }
  },
  created() {
    this.resourceEnterManageInfo.applyOrderId = this.$route.query.applyOrderId
    this.resourceEnterManageInfo.resOrderType = this.$route.query.resOrderType
    this.resourceEnterManageInfo.taskId = this.$route.query.taskId
    this.loadData()
  },
  methods: {
    async loadData() { await this.listPurchaseApply(); await this.loadResourceSuppliers() },
    async listPurchaseApply() {
      try {
        const params = { page: 1, row: 10, applyOrderId: this.resourceEnterManageInfo.applyOrderId, resOrderType: this.resourceEnterManageInfo.resOrderType }
        const data = await listPurchaseApplys(params)
        const purchaseApply = data.purchaseApplys[0]
        Object.assign(this.resourceEnterManageInfo, purchaseApply)
        this.resourceEnterManageInfo.purchaseApplyDetailVo.forEach(item => { item.purchaseQuantity = ''; item.price = ''; item.purchaseRemark = ''; item.rsId = '' })
      } catch (error) { console.error('Failed to load purchase apply:', error) }
    },
    async loadResourceSuppliers() {
      try {
        const params = { page: 1, row: 50 }
        const { data } = await listResourceSuppliers(params)
        this.resourceEnterManageInfo.resourceSuppliers = data
      } catch (error) { console.error('Failed to load resource suppliers:', error) }
    },
    handleSelectionChange(selection) {
      this.resourceEnterManageInfo.selectResIds = selection.map(item => item.resId)
    },
    async handleSubmit() {
      let msg = ''
      const selectedItems = this.resourceEnterManageInfo.purchaseApplyDetailVo.filter(item =>
        this.resourceEnterManageInfo.selectResIds.includes(item.resId)
      )
      if (selectedItems.length < 1) { this.$message.error(this.$t('resourceEnterManage.selectItemError')); return }
      for (const item of selectedItems) {
        if (!item.purchaseQuantity || parseInt(item.purchaseQuantity) < 0) { msg = this.$t('resourceEnterManage.purchaseQuantityError'); break }
        item.purchaseQuantity = parseInt(item.purchaseQuantity)
        if (!item.price || parseFloat(item.price) <= 0) { msg = this.$t('resourceEnterManage.purchasePriceError'); break }
        item.price = parseFloat(item.price)
      }
      if (msg) { this.$message.error(msg); return }
      try {
        const response = await resourceEnter(this.resourceEnterManageInfo)
        if (response.code === 0) { this.$message.success(this.$t('common.operationSuccess')); this.$router.go(-1) }
        else this.$message.error(response.msg)
      } catch (error) { console.error('Submit failed:', error); this.$message.error(this.$t('resourceEnterManage.submitError')) }
    }
  }
}
</script>

<style lang="scss" scoped>
.resource-enter-container { padding: var(--ds-spacing-lg); background-color: var(--ds-gray-100); min-height: calc(100vh - 60px); }
.ds-panel { background: #fff; border: 1px solid var(--ds-gray-300); border-radius: var(--ds-radius-md); box-shadow: var(--ds-shadow-sm); overflow: hidden; margin-bottom: var(--ds-spacing-lg);
  &__title { font-size: var(--ds-font-size-lg); font-weight: 600; color: var(--ds-gray-800); }
}
.ds-order { font-size: var(--ds-font-size-sm); color: var(--ds-gray-600); margin-right: var(--ds-spacing-md); }
</style>
